import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

interface YearSelectComponentProps {
    onChange: (year: number | null) => void;
}

const YearSelectComponent: React.FC<YearSelectComponentProps> = ({ onChange }) => {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 9 }, (_, i) => currentYear - 5 + i);

    // Set default tahun ke tahun saat ini
    const [selectedYear, setSelectedYear] = useState<number>(currentYear);

    // Panggil onChange dengan tahun saat ini saat pertama kali komponen dirender
    useEffect(() => {
        onChange(currentYear);
    }, [onChange, currentYear]);

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const yearValue = event.target.value ? parseInt(event.target.value, 10) : null;
        setSelectedYear(yearValue ?? currentYear); // Jika null, tetap pakai currentYear
        onChange(yearValue);
    };

    return (
        <>
            <Form.Label className="me-2">Select Year:</Form.Label>
            <Form.Select value={selectedYear} onChange={handleChange}>
                {years.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </Form.Select>
        </>
    );
};

export default YearSelectComponent;